function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 12.4c-.4 1.6-.7 3.1-1.5 4.3-.2.4-.5.8-.9 1-.6-3.1.7-5.7 1.2-8.2-.6-1.3-.3-3.5 1.1-3.7 1.9-.4 1.4 2 1.1 3.1-.2.5-.5 1.1-.5 1.8.1 1.4 1.9 1.5 2.7.8 1.3-1 1.7-3 1.5-4.6-.2-2.5-3-3.7-5.5-2.7-1.1.4-2.3 1.6-2.4 3.3-.1.9.1 1.6.4 2.1.1.1.2.2.3.4.1.4-.2.9-.4 1.2-1.3-.4-1.9-1.5-2-2.9-.3-3.3 2.4-5.7 5.5-6 3.4-.2 6 1.7 6.3 4.5.2 2.1-.6 4.2-1.8 5.4-.9.9-2.8 1.7-4.3.9-.3-.2-.5-.4-.8-.7"
});

var SvgPinterest = function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "pinterest",
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export default SvgPinterest;